import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Tooltip,
    Switch, message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {FieldTimeOutlined, SearchOutlined, ReloadOutlined, InfoCircleFilled} from '@ant-design/icons'
import moment from 'moment';
import Edit from './edit.js'
import View from './view.js'
import Yuding from './yuding'


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {}, oldcondition: {}, list: [], tableloading: false, selectedRowKeys: [], count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/fangjian', ['首页', '房间管理'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Room/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    yq_react: data.yq_react ? data.yq_react : [],
                    status_react: data.status_react ? data.status_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    delSel() {
        let that = this
        fetch('/Room/allsave', {
            method: "POST", body: JSON.stringify({
                'id': this.state.selectedRowKeys,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    onSwChange(checked, index) {
        let that = this
        let list = this.state.list ? this.state.list.concat() : []
        fetch('/Room/setStatus', {
            method: "POST", body: JSON.stringify({
                checked,
                edit: 1,
                id: list[index]['id'],
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                }
                list[index]['zlstatus'] = checked
                that.setState({
                    list
                })
            })

    }

    onSwChange2(checked, index) {
        let that = this
        let list = this.state.list ? this.state.list.concat() : []
        fetch('/Room/setStatus', {
            method: "POST", body: JSON.stringify({
                checked,
                edit: 2,
                id: list[index]['id'],
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg)
                }
                list[index]['gnstatus'] = checked
                that.setState({
                    list
                })
            })

    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                id: that.state.selectedRowKeys
            }
        }
        arr.download = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Room/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }

                that.setState({
                    downloading: false
                })
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = data.url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                } catch (e) {
                    alert("下载异常！");
                }
            })
    }


    render() {
        const columns = [{
            title: '所属园区',
            dataIndex: 'yq_id',
            key: 'yq_id',
        }, {
            title: '楼栋',
            dataIndex: 'building',
            key: 'building',
        }, {
            title: '房间号',
            dataIndex: 'number',
            key: 'number',
            render: (row, record) => {
                return (<>
                        <Space>
                            <div>{row}</div>
                            {record.imgnum ? <Tag color={'blue'}>{record.imgnum}图</Tag> : null}
                        </Space>
                        {record.bz ? <div style={{color:'orange'}}>{record.bz}</div> : null}
                </>)
            },
        }, {
            title: '面积',
            dataIndex: 'area',
            key: 'area',
        }, {
            title: '状态',
            dataIndex: 'status',
            key: 'status', render: (row, record) => {
                return (<>
                    {(row == 1 && record.yuding != 1) && <div style={{color: 'red'}}>{record.status_text}</div>}
                    {row == 2 && <div style={{color: 'blue'}}>{record.status_text}</div>}
                    {row == 3 && <div style={{color: 'green'}}>{record.status_text}</div>}
                    {row == 4 && <div style={{color: 'grey'}}>{record.status_text}</div>}
                    {record.yuding == 1 &&
                        <div className={'yyd'}>
                            <span>{record.yuding_text}</span>
                            <Space size={4}>
                                <FieldTimeOutlined/>
                                <span className={'time'}>{record.yuding_d}</span>
                                <span>天</span>
                                <span className={'time'}>{record.yuding_h}</span>
                                <span>时</span>
                            </Space>
                        </div>
                    }
                    {record.daoqi_text &&
                        <div style={{color: '#7552FF'}}>即将到期 <Tooltip
                            title={record.daoqi_text}><InfoCircleFilled style={{color: 'red'}}/></Tooltip></div>
                    }
                </>)
            },
        }, {
            title: '制冷状态',
            dataIndex: 'zlstatus',
            key: 'zlstatus',
            width: 150,
            render: (row, record, index) => {
                return (<>
                    <Space>
                        {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('2') ? <>
                            <Switch checked={row == 0 ? false : true}
                                    onChange={(checked) => this.onSwChange(checked ? 1 : 0, index)}
                                    className={'sw_green'}/>
                        </> : null) : null}
                        {row == 1 && <span style={{color: '#52CC6F'}}>正常</span>}
                        {row == 0 && <span style={{color: '#bfbfbf'}}>已报停</span>}
                    </Space>
                </>)
            },
        }, {
            title: '供暖状态',
            dataIndex: 'gnstatus',
            key: 'gnstatus',
            width: 150,
            render: (row, record, index) => {
                return (<>
                    <Space>
                        {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('2') ? <>
                            <Switch checked={row == 0 ? false : true}
                                    onChange={(checked) => this.onSwChange2(checked ? 1 : 0, index)}
                                    className={'sw_green'}/>
                        </> : null) : null}
                        {row == 1 && <span style={{color: '#52CC6F'}}>正常</span>}
                        {row == 0 && <span style={{color: '#bfbfbf'}}>已报停</span>}
                    </Space>
                </>)
            },
        }, {
            title: '在租企业',
            dataIndex: 'company_name',
            key: 'company_name',
            render: (row, record) => {
                return (<>
                    <div>{row}</div>
                    {record.aliasname ? <div style={{color: 'grey'}}>曾用名：{record.aliasname}</div> : null}
                </>)
            },
        }, {
            title: '操作',
            dataIndex: 'cz',
            key: 'cz',
            align: 'center',
            width: 170,
            render: (row, record) => {
                return (<>
                    <Space>
                        <View id={record.id} refresh={this.getdata.bind(this)}/>
                        {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('2') ? <>
                            <Edit refresh={this.getdata.bind(this)} id={record.id}/>
                        </> : null) : null}
                        {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('2') ? <>
                            {record.yuding == 2 && <Yuding type={1} title1={'预订'} title2={'预订'} id={record.id}
                                                           refresh={this.getdata.bind(this)}/>}
                            {record.yuding == 1 && <Yuding type={2} title={'取消预订'} title2={'取消预订'} id={record.id}
                                                           refresh={this.getdata.bind(this)}/>}
                        </> : null) : null}
                    </Space>
                </>)
            },
        },]
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" align="top" style={{marginBottom: 15}}>
                <Space wrap>
                    <Input className="input" placeholder="请输入关键词"
                           value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                           onChange={this.onChange.bind(this, 'keywords')} autoComplete="off"/>
                    <Select placeholder="所属园区"
                            style={{width: 120}}
                            value={this.state.newcondition.yq_id ? this.state.newcondition.yq_id : null}
                            onChange={this.onSelChange.bind(this, 'yq_id')} allowClear>
                        {this.arrsel(this.state.yq_react)}
                    </Select>
                    <Space size={5}>
                        <Input className="input" placeholder="面积范围"
                               value={this.state.newcondition.area1 ? this.state.newcondition.area1 : null}
                               onChange={this.onChange.bind(this, 'area1')} autoComplete="off"/>
                        <span>~</span>
                        <Input className="input" placeholder="面积范围"
                               value={this.state.newcondition.area2 ? this.state.newcondition.area2 : null}
                               onChange={this.onChange.bind(this, 'area2')} autoComplete="off"/>
                    </Space>
                    <Select placeholder="房间图片"
                            style={{width: 120}}
                            value={this.state.newcondition.sfimg ? this.state.newcondition.sfimg : null}
                            onChange={this.onSelChange.bind(this, 'sfimg')} allowClear showSearch
                            optionFilterProp="children">
                        {this.arrsel([
                            {id: 1, name: '有'},
                            {id: 2, name: '无'},
                        ])}
                    </Select>
                    <Select placeholder="状态"
                            style={{width: 120}}
                            value={this.state.newcondition.status ? this.state.newcondition.status : null}
                            onChange={this.onSelChange.bind(this, 'status')} allowClear showSearch
                            optionFilterProp="children">
                        {this.arrsel(this.state.status_react)}
                    </Select>
                    <Button type="primary" icon={<SearchOutlined/>}
                            onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined/>} className='huise'
                            onClick={this.reset.bind(this)}>重置</Button>
                </Space>
                <Space>
                    <Button type="primary" icon={<SearchOutlined/>} className={'huang'}
                            onClick={() => this.props.history.push("/pingmiantu")}>可视化平面图</Button>
                    {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('2') ?
                        <Edit refresh={this.getdata.bind(this)}/> : null) : null}
                </Space>
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                // scroll={{x:2800}}
                style={{marginBottom: 20}}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_sc ? (store.getState().data.info.lmqx_sc.includes('2') ?
                                <Popconfirm
                                    title="确认删除?"
                                    onConfirm={() => this.delSel()}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="primary" danger>删除</Button>
                                </Popconfirm> : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('2') ?
                                <Button type="primary"
                                        onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('2') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                            current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                            pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                            total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                            showTotal={total => `共 ${total} 条数据`}/>
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname}/>
